const notifications = {
  lockdown: 'Confinamiento',
  door_alarmed: 'Puerta forzada',
  reader_tamper: 'Manipulación del lector',
  tamper: 'Manipulación del gabinete',
  batteries_trouble: 'Problema de batería',
  power_trouble: 'Problema de alimentación principal',
  module_offline: 'Módulo sin conexión',
};

export default notifications;
